if (!customElements.get('gwp-button')) {
  class GWPButton extends HTMLElement {
    constructor() {
      super();
      this.popup = document.querySelector(this.getAttribute('data-target'));
      this.handleDocumentKeyup = this.handleDocumentKeyup.bind(this);
      this.handlePopupClick = this.handlePopupClick.bind(this);
      this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleButtonClick);
      if (this.popup) {
        this.popup.addEventListener('click', this.handlePopupClick);
        document.addEventListener('keyup', this.handleDocumentKeyup);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleButtonClick);
      if (this.popup) {
        this.popup.removeEventListener('click', this.handlePopupClick);
      }
      document.removeEventListener('keyup', this.handleDocumentKeyup);
    }

    handleButtonClick() {
      this.openPopup();
    }

    handlePopupClick(event) {
      if (event.target === event.currentTarget || event.target.closest('.gwp-popup__close')) {
        this.closePopup();
      }
    }

    handleDocumentKeyup(event) {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode === 'ESCAPE') this.closePopup();
    }

    // Open/close instead of toggle: every gwp-button (drawer + cart page) listens
    // on the same popup and document, so a toggle ran once per button - Escape
    // opened the closed popup and the close X reopened it when two were present.
    openPopup() {
      this.popup && this.popup.classList.add('open');
    }

    closePopup() {
      this.popup && this.popup.classList.remove('open');
    }
  }

  customElements.define("gwp-button", GWPButton);
}
